<!--
 * @Date: 2022-09-02 13:35:57
 * @LastEditors: Cclay
 * @LastEditTime: 2023-10-07 19:18:45
 * @FilePath: \zl_api_private_web\src\views\webGraspManage\multiAccountWebsite\index.vue
 * @Description: 我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我
-->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>多账号网站</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      多账号网站
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条</div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="broker_name" label="商业公司">
            </el-table-column>
            <el-table-column prop="website_address" label="网站">
            </el-table-column>
            <el-table-column prop="account_number" label="账号数">
            </el-table-column>

            <el-table-column prop="operation" label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="onSee(scope.$index, scope.row)"
                  type="text"
                  size="small"
                >
                  查看数据
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getMultipleWebscrap } from "@/api/index";

export default {
  name: "",
  data: () => ({
    currentPage: 1,
    tableData: [],
    totalCount: 0
  }),
  created() {
    this._getList();
  },
  methods: {
    _getList() {
      getMultipleWebscrap().then(res => {
        if (0 === res.status) {
          this.tableData = res.data.list;
          this.totalCount = res.data.directWebManage;
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      });
    },
    onSee(index, row) {
      //webGraspManageMultiAccountWebsiteList
      let r = this.$router.resolve({
        name: "webGraspManageMultiAccountWebsiteList",
        params: { web_scrap_id: row.web_scrap_id }
      });
      window.open(r.href);
    }
  }
};
</script>

<style scoped></style>
